import { usePreferenceContext } from "../../../context/PreferencesContext";
import useFormatNumbers from "../../../customHooks/useFormatNumbers";
import useRTL from "../../../customHooks/useRTL";
import Title from "../Title";
import ShortName from "./ShortName";

import RequiredAmount from "./RequiredAmount";
import TitleLogo from "./TitleLogo";

type Props = {
  title: string;
  shortName?: string;
  onEditEventClick?: () => void;
  editable?: boolean;
  required_amount?: {
    label: string;
    amount: {
      [key: string]: number;
    };
  };
  noReqAmount?: boolean;
};
const ImageTitle = ({
  title,
  shortName,
  required_amount,
  editable,
  onEditEventClick,
  noReqAmount,
}: Props) => {
  const isRTL = useRTL();
  const { formatNumbers } = useFormatNumbers();
  const { curr } = usePreferenceContext();
  return (
    <div>
      <div
        className={`d-flex border-bottom py-4 align-items-center text-${
          isRTL ? "right" : "left"
        }`}
      >
        <TitleLogo className="mx-auto" width={72} height={72} />
        <div className="ms-3 flex-1 w-100">
          <Title
            variant="h4"
            smCenter
            title={title}
            actionButton={
              editable && (
                <i
                  onClick={onEditEventClick}
                  className="fe-edit fs-xxl text-primary ms-2 mb-0 mb-md-2 cursor"
                ></i>
              )
            }
            noDesc={noReqAmount}
            desc={
              <RequiredAmount
                size="lg"
                className="d-none d-md-block"
                label={required_amount?.label}
                requiredAmount={formatNumbers(
                  required_amount?.amount[curr?.code]
                )}
              />
            }
            titleMb="mb-0 mb-md-2"
          />
        </div>
      </div>
      <div className="border-bottom py-3 d-flex d-md-none justify-content-between fs-lg">
        {noReqAmount ? (
          <div />
        ) : (
          <RequiredAmount
            className=""
            size="md"
            label={required_amount?.label}
            requiredAmount={formatNumbers(required_amount?.amount[curr?.code])}
          />
        )}
        <span className="fs-md">
          {shortName ? <ShortName shortName={shortName} /> : null}
        </span>
      </div>
    </div>
  );
};

export default ImageTitle;
